import { render, staticRenderFns } from "./ReceiptCopyPreviewWithOverlay.vue?vue&type=template&id=c97ee430&scoped=true&"
import script from "./ReceiptCopyPreviewWithOverlay.vue?vue&type=script&lang=js&"
export * from "./ReceiptCopyPreviewWithOverlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c97ee430",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VHover } from 'vuetify/lib/components/VHover';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFadeTransition,VHover,VOverlay,VRow})
